import { render } from "./SagePay.vue?vue&type=template&id=76b22d7d&ts=true"
import script from "./SagePay.vue?vue&type=script&lang=ts"
export * from "./SagePay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__